import { LanguageResourcePack } from "@buzzeasy/shared-frontend-utilities";
import { Locale } from "antd/es/locale";

import antEnUS from "antd/lib/locale/en_US";
import antDeDE from "antd/lib/locale/de_DE";
import antEsES from "antd/lib/locale/es_ES";
import antFrFR from "antd/lib/locale/fr_FR";
import antHuHU from "antd/lib/locale/hu_HU";
import antItIT from "antd/lib/locale/it_IT";
import antNlNL from "antd/lib/locale/nl_NL";
import antRoRO from "antd/lib/locale/ro_RO";
import antSrRS from "antd/lib/locale/sr_RS";
import antTrTR from "antd/lib/locale/tr_TR";
import antCsCZ from "antd/lib/locale/cs_CZ";
import antPlPL from "antd/lib/locale/pl_PL";
import antskSK from "antd/lib/locale/sk_SK";
import antslSI from "antd/lib/locale/sl_SI";

import enUS from "./en-US.json";
import deDE from "./de-DE.json";
import esES from "./es-ES.json";
import frFR from "./fr-FR.json";
import huHU from "./hu-HU.json";
import itIT from "./it-IT.json";
import nlNL from "./nl-NL.json";
import roRO from "./ro-RO.json";
import srRS from "./sr-RS.json";
import trTR from "./tr-TR.json";
import csCZ from "./cs-CZ.json";
import plPL from "./pl-PL.json";
import skSK from "./sk-SK.json";
import slSI from "./sl-SI.json";

export const translations: LanguageResourcePack = {
  "en-US": enUS,
  "de-DE": deDE,
  "es-ES": esES,
  "fr-FR": frFR,
  "hu-HU": huHU,
  "it-IT": itIT,
  "nl-NL": nlNL,
  "ro-RO": roRO,
  "sr-RS": srRS,
  "tr-TR": trTR,
  "cs-CZ": csCZ,
  "pl-PL": plPL,
  "sk-SK": skSK,
  "sl-SL": slSI,
};

export const antLocales: Record<string, Locale> = {
  "en-US": antEnUS,
  "de-DE": antDeDE,
  "es-ES": antEsES,
  "fr-FR": antFrFR,
  "hu-HU": antHuHU,
  "it-IT": antItIT,
  "nl-NL": antNlNL,
  "ro-RO": antRoRO,
  "sr-RS": antSrRS,
  "tr-TR": antTrTR,
  "cs-CZ": antCsCZ,
  "pl-PL": antPlPL,
  "sk-SK": antskSK,
  "sl-SI": antslSI,
};
